<script lang="ts">
    import { getMedia } from "../api"
    import { apiBaseURL as apiBaseURL_conf } from "../config"
    import { sprache } from "../store"

    export let imageId: string
    export let image_: Media
    export let size: string = "xl"
    export let showCaption: boolean = false

    export let apiBaseURL: string = apiBaseURL_conf

    if (!image_ && imageId && typeof fetch !== "undefined") {
        fetch(apiBaseURL + "media/" + imageId)
            .then((res) => res.json())
            .then((res) => {
                image_ = res
            })
    }
</script>

<section class="image">
    {#if imageId && image_}
        <img src="{apiBaseURL + 'media/' + imageId + '/' + image_?.file?.src + '?filter=' + size}" alt="" />
    {/if}
    {#if showCaption}
        <div class="caption">
            {image_?.title ? image_.title[$sprache] : ""}{image_?.author ? " " + image_.author[$sprache] : ""}
        </div>
    {/if}
</section>
